import React from 'react'
import DatePicker from 'react-datepicker';


const LogFilter = ({ startDate, endDate, onDateChange }) => {


    return (
        <div className="d-flex">
            <div className="trip d-flex flex-column align-items-baseline w-full date-picker-container">
                <small className='font-13 font-weight-500'>From : </small>
                <div className="d-flex">
                    <i className="fa fa-calendar  mt-2_5 text-success ml-2 font-12"></i>
                    <DatePicker
                        selected={startDate ? startDate : null}
                        onChange={onDateChange ? (date) => onDateChange("startDate", date) : null}
                        dateFormat='dd-MM-yyyy'
                        className="font-13"
                    />
                </div>
            </div>
            <div className="trip d-flex flex-column align-items-baseline w-full w-full date-picker-container">
                <small className='font-13 font-weight-500'>To : </small>
                <div className="d-flex">
                    <i className="fa fa-calendar  mt-2_5 text-success ml-2 font-12"></i>
                    <DatePicker
                        selected={endDate ? endDate : null}
                        onChange={onDateChange ? (date) => onDateChange("endDate", date) : null}
                        dateFormat='dd-MM-yyyy'
                        className="font-13"
                    />
                </div>
            </div>

        </div>
    )
}

export default LogFilter
